import React, { useImperativeHandle, forwardRef, useState } from 'react';
import { validateInit, validateForm } from '@assets/js/util/formValidation.js';
import { formAtt } from '@assets/js/util/commonUtil.js';
import CompFmtInput from '@components/form/fragment/comp-fmt-input.js';
import {ApiSave} from '@assets/js/api/commonApi.js';

const CompFormPlayer = forwardRef((props, ref) => {
    const [params, setParams] = useState({});
    
    /****************************
     * Define required variables
    *****************************/
    const rooId = 'modalSheet';
    const validateOpt = {
        scopeEle: document.querySelector('#' + rooId),
        targetIds: ['plyrNm', 'email', 'telno'],
        params: params,
    }

    /*************************
     * Define react functions
    **************************/
    // Forward ref to allow parent components to call event functions.
    useImperativeHandle(ref, () => ({
        modalToggle(p_params) {
            handleToggle();
            setParams(p_params || {});
        },
    }));

    /**********************
     * Define functions
    ***********************/
    const handleToggle = () => {
        const targetEle = document.querySelector('#' + rooId);
        if (targetEle) {
            targetEle.style.display = targetEle.style.display === 'none' ? 'block' : 'none';
        }

        // Reset form inputs and validation state
        validateInit(validateOpt);

        Object.keys(formObj).forEach(key => {
            const ele = targetEle.querySelector(`#${formObj[key].id}`);
            if (ele) { ele.value = ''; }
        });
    }
    const onSave = () => {
        // Validate form inputs before saving
        if (!validateForm(validateOpt)) { return; }

        // Fetch data from the server
        ApiSave('/sys/plymng/save/info', params).then(res => {
            if (res && res.success) {
                // Close the modal after saving
                handleToggle();
                // Search for updated data
                props.onGridSearch();
            }
        });
    }
    const onValChange = (e) => {
        const { id } = e.target;
        // Validate the specific input field
        validateForm(validateOpt, id);
    }
    const onInputChange = (e) => {
        const { id, value } = e.target;
        // Update the state with the new value only (no validation)
        setParams({ ...params, [id]: value });
    }

    /****************************
     * Define form config
    *****************************/
    const formObj = {
        plyrCd : formAtt({id: 'plyrCd', label: '선수코드', value: params['plyrCd'] || '', disabled: true}),
        plyrNm : formAtt({id: 'plyrNm', label: '선수명', value: params['plyrNm'] || '', required: true}),
        email  : formAtt({id: 'email', label: '이메일', value: params['email'] || '', required: true}),
        telno  : formAtt({id: 'telno', label: '전화번호', value: params['telno'] || '', required: true}),
        natNm  : formAtt({id: 'natNm', label: '국가', value: params['natNm'] || '', required: true}),
    }

    return (
        <>
            <div 
                className="modal modal-sheet p-1 py-md-5"
                style={{ display: 'none', backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
                tabIndex={-1}
                role="dialog"
                id={rooId}
            >
                <div className="modal-dialog">
                    <div className="modal-content rounded-4 shadow">
                        <div className="modal-header border-bottom-0">
                            <h1 className="modal-title fs-5">선수정보 등록/수정</h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={handleToggle}
                            />
                        </div>
                        <div className="modal-body py-0">
                            <div className="row g-5">
                                <div className="col-lg-12">
                                    <form className="needs-validation" noValidate="">
                                        <div className="row">
                                            <CompFmtInput
                                                attrs={formObj.plyrCd}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.plyrNm}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.email}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.telno}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                            <CompFmtInput
                                                attrs={formObj.natNm}
                                                onChange={onInputChange}
                                                onBlur={onValChange}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex-column align-items-stretch w-100 gap-2 pb-3 border-top-0">
                            <div className="btn-group">
                                <button type="button" className="btn btn-lg btn-primary" onClick={onSave}>
                                    Save changes
                                </button>
                                <button type="button" className="btn btn-lg btn-secondary" data-bs-dismiss="modal" onClick={handleToggle}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </> 
    );
});

export default CompFormPlayer;